import instance from '../utils/axios';

class stockTakingService {
    async getStockTakingList(pageIndex, keyword) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: "creatorId.base_staff,warehouseId.psi_warehouse,status.dict_stocktaking_complete_status",
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime desc'
        }
        return await instance.post('/electronerp/stockTakingManger/getStockTakingList', data);
    }
    async getStockTakingCategoryList(pageIndex, keyword,uuid) {
        // eslint-disable-next-line no-mixed-spaces-and-tabs
        const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: "categoryId.psi_sku_category,status.dict_stocktaking_complete_status",
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'uuid desc',
            uuid:uuid
        }
        return await instance.post('/electronerp/stockTakingManger/getStockTakingCategoryList', data);
    }
    async getStockTakingCategorySkuList(pageIndex, keyword,uuid) {
        // eslint-disable-next-line no-mixed-spaces-and-tabs
        const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: "skuId.psi_sku,code.v_psi_sku_code,status.dict_stocktaking_complete_status",
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'uuid desc',
            uuid:uuid
        }
        return await instance.post('/electronerp/stockTakingManger/getStockTakingCategorySkuList', data);
    }
    async getStockTakingCategorySkuBarcodeList(pageIndex, keyword,uuid,isEnable) {
        // eslint-disable-next-line no-mixed-spaces-and-tabs
        const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: isEnable=="11"?"barcodeId.v_psi_barcode,binId.v_psi_warehouse_shelf_bin":"skuId.psi_sku,code.v_psi_sku_code",
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime desc',
            uuid:uuid,
            isEnable:isEnable
        }
        return await instance.post('/electronerp/stockTakingManger/getStockTakingCategorySkuBarcodeList', data);
    }
    async getZLSelectDict(dictionaryName) {
        return await instance.get('/crm/common/CommonApi/GetZLSelectDict?dictionaryName='+dictionaryName);
    }
    async insertStocktaking(warehouseId) {
        const data = {
            warehouseId: warehouseId,
        }
        return await instance.post('/electronerp/stockTakingManger/insertStocktaking',data);
    }
    async updateStocktakingStatus(uuid) {
        const data = {
            uuid: uuid,
        }
        return await instance.post('/electronerp/stockTakingManger/updateStocktakingStatus',data);
    }
    async updateStocktakingCategoryStatus(uuid) {
        const data = {
            uuid: uuid,
        }
        return await instance.post('/electronerp/stockTakingManger/updateStocktakingCategoryStatus',data);
    }
    async saveStocktaking(skuId,barcodeIds,isEnable,status,binAndNumber,stocktakingSkuNumber) {
        const data = {
            skuId: skuId,
            barcodeIds: barcodeIds,
            isEnable: isEnable,
            status: status,
            binAndNumber: JSON.stringify(binAndNumber),
            stocktakingSkuNumber: stocktakingSkuNumber,
        }
        return await instance.post('/electronerp/stockTakingManger/saveStocktaking',data);
    }
    async getPsiBarcodeList (skuId)  {
        const data = {
            skuId: skuId,
            dictionaryNames: "binId.v_psi_warehouse_shelf_bin",
        }
        return await instance.post('/electronerp/stockTakingManger/getPsiBarcodeList',data);
    }

}

export default new stockTakingService();